import React from 'react';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { TaskCreateContent } from './TaskCreateContent';

export class TaskCreateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_TASKS,
            Breadcrumbs.MY_OUTSOURCES_TASKS_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage breadcrumbs={breadcrumbs} title={I18nUtils.tr('TR_MI_NUEVA_TAREA')}>
                <TaskCreateContent/>
            </PsPage>
        );
    }
}

TaskCreateScreen.propTypes = {};

TaskCreateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/form/create/TaskCreateScreen.jsx